import Header from './src/main'

Header.install = function (Vue) {
    Vue.components(Header.name, Header)
}

export default Header